import { jsx as _jsx } from "react/jsx-runtime";
import IntlConfigContext from '../../../internal/config/IntlConfigContext';
/**
 * @see https://sail.stripe.me/apis/intl/IntlProvider
 */ export default function IntlProvider({ children, config }) {
    return /*#__PURE__*/ _jsx(IntlConfigContext.Provider, {
        value: config,
        children: children
    });
}

//# sourceMappingURL=IntlProvider.js.map